import { FunctionComponent, useEffect } from "react";
import { QuestionIcon } from "@/form/components/common/icons";
import ShareLinkModal from "@/components/common/ShareLinkModal";
import { useState } from "react";
import { Button, CopyButton } from "@mantine/core";
import { Add1Icon } from "@form/components/common/icons";
import Router from "next/router";
import useAccount from "@/hooks/useAccount";
import useClaimerContract from "@/hooks/useClaimerContract";
import useRequest from "@/hooks/useRequest";
import { ZetaChain_Test } from "@/chain-info/ZetaChain";

const ROLE_DESC = ["Scientist", "Engineer", "Doctor", "Security", "Artist"];

const ClaimerMintResult: FunctionComponent<{
  nftMeta: {
    score: number;
    role: number;
    validator: number;
  } | null;
  chainId: number;
}> = ({ nftMeta, chainId }) => {
  const [shareLinkOpened, setShareLinkOpened] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const { address } = useAccount();
  const claimerContract = useClaimerContract(chainId);

  const role = nftMeta ? nftMeta.role : (claimerContract.role as number);

  const { data: validatorInfo } = useRequest<{
    validatorTokenId: number;
    role: number;
    karatScore: number;
    id: string;
  }>(
    address
      ? {
          function: "network/getValidatorOfClaimer",
          data: {
            address,
            role,
          },
          header: {
            endpoint: "network",
          },
        }
      : null
  );

  const validatorId = nftMeta
    ? nftMeta.validator
    : validatorInfo?.validatorTokenId;

  useEffect(() => {
    if (!address || typeof validatorId === "undefined") {
      return setShareLink("");
    }
    setShareLink(
      `${window.location.origin}/mint/claimer?lieutenantAddress=${address}&validatorId=${validatorId}`
    );
  }, [address, validatorId]);

  return (
    <div className="max-w-[629px] mx-auto pb-[115px] px-5 sm:px-0 mt-10 sm:mt-[83px] animate__animated animate__fadeInUp">
      <div
        className="bg-[#EBF3FF] rounded-2xl p-4 sm:p-20 flex flex-col items-center"
        style={{
          boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)",
        }}
      >
        <img className="w-full" src="/assets/mint/demo-id-card.png"></img>
        <div className="text-[28px] font-bold text-dark1  text-center max-w-[409px]">
          Congrats, you received the role of a {ROLE_DESC[role]}!
        </div>

        <div className="mt-2 text-dark1 text-center max-w-[409px] leading-snug">
          <div className="flex items-center justify-center">
            <span>Your role was selected based on your KARAT score</span>
            <QuestionIcon className="inline w-3 h-3 fill-primary ml-1 mt-[2px] action"></QuestionIcon>
          </div>
          <div>
            {" "}
            In addition to this NFT, you’ll also receive KARAT tokens in the
            near future. Stay tuned for the token airdrop
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-6">
        <div className="relative">
          {shareLink && (
            <CopyButton value={shareLink}>
              {({ copied, copy }) => (
                <div
                  className="flex items-center justify-center font-medium action text-primary text-sm"
                  onClick={copy}
                >
                  <Add1Icon></Add1Icon>
                  <span className="ml-2">
                    {copied ? "Copied 🎉" : "Copy referral link"}
                  </span>
                </div>
              )}
            </CopyButton>
          )}

          {/* <Button
            classNames={{
              inner: "text-body ",
              root: "w-[255px] mt-4",
            }}
            size="md"
            radius="xl"
            onClick={() => {
              router.push("/dashboard/network");
            }}
          >
            Go to dashboard
          </Button> */}
          <Button
            classNames={{
              inner: "text-body ",
              root: "w-[255px] mt-4",
            }}
            size="md"
            radius="xl"
            onClick={() => {
              if (chainId === ZetaChain_Test.chainId) {
                Router.push("/dashboard/network");
              } else {
                window.open(
                  `https://www.okx.com/web3?wallet=${address}`,
                  "_blank"
                );
              }
            }}
          >
            View your NFT
          </Button>
          <div className="absolute w-[250px] left-[-100px] sm:right-0 sm:left-[-50px] bottom-[54px]">
            <ShareLinkModal
              opened={shareLinkOpened}
              setOpened={setShareLinkOpened}
              link={shareLink}
            ></ShareLinkModal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimerMintResult;
